'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _servicesAndOperations = require('../actions/servicesAndOperations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getServicesList),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getInsuranceServicesList),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(servicesAndOperationsSaga);
// URLs


function getServicesList(action) {
  var header, getServicesApi, getServicesApiResponse;
  return _regenerator2.default.wrap(function getServicesList$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          header = [{
            key: 'countryId',
            value: action.payload.countryId
          }];
          getServicesApi = new _webUtils.API();
          _context.next = 4;
          return getServicesApi.get(_webUtils.Urls.getServicesAndChildServices + '?specialtyCountryKey=' + action.payload.serviceCountryKey, header);

        case 4:
          getServicesApiResponse = _context.sent;

          if (!_webUtils.STATUS.isSuccess(getServicesApiResponse.status)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return (0, _effects.put)({
            type: _servicesAndOperations.SERVICES.GET_SERVICES.SUCCESS,
            list: getServicesApiResponse.data
          });

        case 8:
          _context.next = 12;
          break;

        case 10:
          _context.next = 12;
          return (0, _effects.put)({
            type: _servicesAndOperations.SERVICES.GET_SERVICES.FAIL,
            error: getServicesApiResponse.data
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function getInsuranceServicesList(action) {
  var header, getInsuranceServicesApi, getInsuranceServicesApiResponse;
  return _regenerator2.default.wrap(function getInsuranceServicesList$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          header = [{
            key: 'countryId',
            value: action.payload.countryId
          }];
          getInsuranceServicesApi = new _webUtils.API();
          _context2.next = 4;
          return getInsuranceServicesApi.get(_webUtils.Urls.getInsuranceServicesAndChildServices + '?specialtyCountryKey=' + action.payload.serviceCountryKey + '&insuranceKey=' + action.payload.insuranceKey, header);

        case 4:
          getInsuranceServicesApiResponse = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(getInsuranceServicesApiResponse.status)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return (0, _effects.put)({
            type: _servicesAndOperations.SERVICES.GET_INSURANCE_SERVICES.SUCCESS,
            list: getInsuranceServicesApiResponse.data
          });

        case 8:
          _context2.next = 12;
          break;

        case 10:
          _context2.next = 12;
          return (0, _effects.put)({
            type: _servicesAndOperations.SERVICES.GET_INSURANCE_SERVICES.FAIL,
            error: getInsuranceServicesApiResponse.data
          });

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function servicesAndOperationsSaga() {
  return _regenerator2.default.wrap(function servicesAndOperationsSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_servicesAndOperations.SERVICES.GET_SERVICES.LOAD, getServicesList);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_servicesAndOperations.SERVICES.GET_INSURANCE_SERVICES.LOAD, getInsuranceServicesList);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = servicesAndOperationsSaga;
module.exports = exports['default'];